export interface DashboardTotalLicencesLiveButEndedDTO {
  liveButEndDated: number;
};

export function DashboardTotalLicencesLiveButEndedDTO_EmptyObject(): DashboardTotalLicencesLiveButEndedDTO {
  return {
    liveButEndDated: 0
  }
};
